var map = {
	"./black-pepper-kitchen.png": 5013,
	"./eight-nine-crafts-and-art.png": 6388,
	"./eight-nine.png": 3014,
	"./heart-travellers-and-adventures.png": 7619,
	"./luko-works.png": 8470,
	"./mlatho-farms.png": 7479,
	"./start-up-malawi.png": 8902,
	"./this-can-be-you.png": 5149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4110;